export default "/images/cancel-application.png?0d1b23b1c2c74617fe2962d458b8aeb4";